import React from 'react';
import { useGesture } from '../context/GestureContext';
import './GestureStatus.css';

const GestureStatus = () => {
    const { cardNavActive, gesturesEnabled } = useGesture();

    if (!gesturesEnabled) return null;

    return (
        <div className={`gesture-status-badge ${cardNavActive ? 'active' : 'inactive'}`}>
            <span className="status-dot"></span>
            <span className="status-text">
                Card Mode: {cardNavActive ? 'ON' : 'OFF'}
            </span>
        </div>
    );
};

export default GestureStatus;
